export const HttpStatus = {
  // Success
  SUCCESS: 200,
  // Created
  CREATED_SUCCESS: 201,
  // Accepted
  ACCEPTED: 202,
  // No Content
  NO_CONTENT: 204,
  // Bad Request
  BAD_REQUEST: 400,
  // Unauthorized
  UNAUTHORIZED: 401,
  // Forbidden
  FORBIDDEN: 403,
  // Bad Request
  NOT_FOUND: 404,
  // Error Server
  INTERNAL_SERVER_ERROR: 500,
  // SERVICE UNAVAILABLE
  SERVICE_UNAVAILABLE: 503,
  // OTHER
  OTHER: -1,
};
